import { useState } from 'react';

const WA_LINK = 'https://wa.me/5511981882825';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-7 right-7 z-[9999] flex items-center gap-3">
      <div
        className={`transition-all duration-300 ease-out ${
          hovered
            ? 'opacity-100 translate-x-0 pointer-events-auto'
            : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div className="bg-white text-navy px-4 py-2.5 rounded-full shadow-lg text-sm font-sans font-600 whitespace-nowrap border border-green-100">
          Fale conosco pelo WhatsApp!
        </div>
      </div>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Fale conosco pelo WhatsApp"
        className="w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-xl cursor-pointer transition-transform duration-200 hover:scale-110"
        style={{ boxShadow: '0 4px 24px 0 rgba(37,211,102,0.35)' }}
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
      </a>
    </div>
  );
}
